// Prettify a chain slug for display: "trgovina-krk" -> "Trgovina Krk".
// Unicode-aware: only the first letter after the start or a space is upper-cased,
// so Croatian diacritics mid-word survive ("košara" -> "Košara", not "KošAra" —
// the old ASCII \b\w treated š/ć/ž as a word boundary).
export function prettyChain(slug) {
  return String(slug)
    .replace(/[-_]+/g, ' ')
    .replace(/(^|\s)(\p{L})/gu, (_m, sep, ch) => sep + ch.toUpperCase())
}
